import React, { useEffect, useState } from 'react'
import Dialog from '@material-ui/core/Dialog'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'
import { Container, Wrapper, Header, HeaderTitle, Body, Footer } from './styles'
import { useSelector } from 'react-redux'
import { selectTableSlice } from '1.newComponents/Table/tableSlice'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction='up' ref={ref} {...props} />
})

export default function FullScreenDialog ({ open, selectedId, handleClose }) {
  const tableSlice = useSelector(selectTableSlice)
  const [crf, setCrf] = useState({})
  useEffect(() => {
    const { dataList } = tableSlice
    const crfData = dataList.find(data => data._id === selectedId)
    setCrf(crfData)
  }, [selectedId])
  return (
    <div style={{ marginLeft: '250px' }}>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <Container>
          <Wrapper>
            <Header>
              <HeaderTitle>
                <h1>{`CRF # ${crf?.crfNo}`}</h1>
                <p>{`Request Type: ${crf?.requestType}`}</p>
              </HeaderTitle>
              <IconButton
                edge='start'
                color='inherit'
                onClick={handleClose}
                aria-label='close'
              >
                <CloseIcon />
              </IconButton>
            </Header>
          </Wrapper>
        </Container>
      </Dialog>
    </div>
  )
}
